var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand-box"},[_c('h4',[_vm._v(_vm._s(_vm.name))]),_c('img',{attrs:{"src":_vm.list_pic_url,"alt":""}}),_c('p',[_vm._v(" "+_vm._s(_vm.simple_desc)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }